/**
 * i18n key 命名规范
 * 按照模块区分，[moduleName].[textName]，最后会merge到一起，这样便于管理
 * */

const message = {
  /* ----课程 ------ */
  Credits: 'Credits',
  Credit: 'Credit',
  Elective: 'Elective',
  Compulsory: 'Compulsory',
  Submit: 'Submit',
  Progress: 'Progress',
  Twitter: 'Twitter',
  Linkedin: 'Linkedin',
  Facebook: 'Facebook',
  share: 'share',
  Tips: 'Tips',
  Cancel: 'Cancel',
  Ok: 'OK',
  Certification: 'Certification',
  '10/page': '10/page',
  '20/page': '20/page',
  '30/page': '30/page',
  '40/page': '40/page',
  '16/page': '16/page',
  '32/page': '32/page',
  '64/page': '64/page',
  '128/page': '128/page',
  /* 考试详情 */
  Sorry: 'Sorry',
  /** footer */
  GSC: 'GSC',
  HSC: 'HSC',
  /** footer */
  /* ---- 认证 ------ */
  'Theory Exam': 'Theory Exam',
  'Practical Exam': 'Practical Exam',
  'The curriculum includes': 'The curriculum includes compulsory and elective courses.',
  'You can learn in': 'You can learn in one of the following ways.',
  'You need to pass the theory test': 'You need to pass the theory test before you can sign up.',
  'You need to sign up': 'You need to sign up for the course before you can continue your study',
  About: 'About',
  Gain: 'Complete the compulsory courses, pass the exam, and gain ',
  'Release time:': 'Release time: ',
  'Compulsory Courses': 'Compulsory Courses',
  'Elective Courses': 'Elective Courses',
  'Take the Exam': 'Take the Exam',
  'Registration failed': 'Registration failed, please update your personal information and re-register',
  'Registration approval': 'Registration approval is expected to be completed within 3 days after registration.',
  'The examination is divided into': 'The examination is divided into theoretical examination and practical examination. Some courses only have theoretical examination. If you pass the examination, you can apply for certification',
  'You have passed the exam': 'You have now passed the exam. Go and apply for certification!',
  applyCertificate: 'Apply for Certification',
  'Are you sure you would like to enroll in this certification?': 'Are you sure you would like to enroll in this certification?',
  /* ---- 个人中心 ------ */
  userNoCertificate: 'You have not earned any certificates yet.',
  userNoClassroom: 'You have not completed any classroom training yet.',
  userNoTest: 'You have not taken any exams or quizzes yet.',
  'No classroom': 'No classroom',
  avatarLimit: 'A JPG or PNG file up to 200 Kb',
  'No courses': 'No courses'
}

// 首页
const homeModule = {
  'home.buildSkill': 'Start building skills today',
  'home.certificateTitle': 'Certification programs',
  'home.viewMore': 'View more',
  'home.generalCertiTitle': 'General Security Certification Program',
  'home.generalCertiDesc': 'The General Security Certification Program focuses on the universal knowledge and skills needed in the security industry, from technical principles to typical solution design. This program helps individuals and organizations prove their competence in the security business.',
  'home.hikCertiTitle': 'Hikvision Security Certification Program',
  'home.hikCertiDesc': "The Hikvision Security Certification Program revolves around Hikvision products and solutions, covering system configuration, operation, troubleshooting, and more. This program aims to enable quick transfer of Hikvision's product and technical capabilities to distributors, system integrators, and installers.",
  'home.trainerTitle': 'Meet our trainers',
  'home.meetOur': 'Meet our',
  'home.trainers': 'trainers',
  'home.trainerDesc': 'Hikvision eLearning platform has brought together a professional and international team of trainers – Hikvision Certified Instructors – including in-house instructors and instructors from third-party institutions.   Each of our talented and experienced instructors is a good mentor for your quick learning and development in the security industry.',
  'home.whatsNew': "What's new",
  'home.userComment': 'What users say about us',
  'home.buildSkillDesc': 'Hikvision eLearning platform aims to help security-industry practitioners enhance their professional competence through learning and certification. The platform also provides preliminary training and insights for those who wish to start out in the security industry. We welcome installers, integrators, engineers, students, and anyone else who is interested in the security industry to use this platform for training and certification. We will help you manage your training certificates, enhance your resume, and stay ahead of competitors.',
  'home.skillBuild1': 'Professional, structured curriculum',
  'home.skillBuild2': 'Professional, structured curriculum',
  'home.skillBuild3': 'Professional, structured curriculum',
  'home.skillBuildDesc1': 'With industry experience and expertise gained in the past 20 years, we provide comprehensive and diverse courses from fundamental skills to system design to meet the needs of different learner groups.',
  'home.skillBuildDesc2': 'With industry experience and expertise gained in the past 20 years, we provide comprehensive and diverse courses from fundamental skills to system design to meet the needs of different learner groups.',
  'home.skillBuildDesc3': 'With industry experience and expertise gained in the past 20 years, we provide comprehensive and diverse courses from fundamental skills to system design to meet the needs of different learner groups.',
  'home.start': 'start',
  'home.welcomeBack': 'Welcome back eLearning,',
  'home.areUReady': 'ready for your next lesson?',
  'home.recommendedCourse': 'Recommended courses',
  'home.recommendedClassroom': 'Recommended classrooms',
  'home.courses': 'Courses'
}
// 线上课程
const courseModule = {
  'course.feedbackRate': 'Rate the course:',
  'course.gradeCourseRate': 'Grade the course:',
  'course.feedbackPlaceholder': 'Please fill in the feedback on the course here',
  'course.feedbackDialogRate': 'Rate your experience in this course',
  'course.feedbackDialogTip': 'Please leave comments here to help us improve the course.',
  'course.filter': 'Course Filters',
  'course.filter.course': 'Course',
  'course.filter.topic': 'Topic',
  'course.filter.courseType': 'Course type',
  'course.filter2': 'Filter',
  'course.startQuiz': 'Start the quiz',
  'course.takeTheQuiz': 'Take the quiz',
  'course.start': 'Start',
  'course.allCourse': 'All Courses',
  'course.takeCourse': 'Take Training Courses',
  'course.courseType': 'Certification Type',
  'course.courseSubType': 'Certification Subtype',
  'course.requirement': 'Course Requirement',
  'course.reset': 'Reset',
  'course.more': 'More',
  'course.less': 'Less',
  'course.releaseTime': 'Release time',
  'course.logToLearn': 'Log in to learn this course',
  'course.breadcrumbItem': 'Certification Overview',
  'course.courseList': 'Educational Video',
  'course.courses': 'Courses',
  'course.pleaseLogin': 'Please register an account or log in to eLearning.',
  'course.applicationBeingReview': 'The enrollment application is under review.',
  'course.pleaseEnroll': 'Please enroll in the course.',
  'course.enrollCourse': 'Enroll in this course',
  'course.applicationPending': 'Application being reviewed',
  'course.joinLearning': 'Join learning',
  'course.lessonOverview': 'Lesson Overview',
  'course.outline': 'Course outline',
  'course.trainerTeam': 'Trainer Team',
  'course.feedback': 'Feedback',
  'course.relatedLink': 'Related links',
  'course.shareVia': 'Share via',
  'course.overview': 'Course Overview',
  'course.replay': 'Replay',
  'course.startQuizTip': 'You can start quiz after completing the course.',
  'course.quizRuleTitle': 'Test Rules',
  'course.startNow': 'Start now',
  'course.passQuiz': 'You have passed this quiz.',
  'course.takeOtherCourses': 'Take other courses',
  'course.updateTip': 'The course has been replaced by the new version, your learning progress of this course is automatically changed to 100%, your obtained credits of this certification is kept.',
  'course.video.replay': 'Replay',
  'course.video.next': 'Next',
  'course.learning': 'Learning',
  'course.quiz': 'Quiz',
  'course.complete': 'Completed',
  'course.tryAgain': 'Please try again',
  'course.takeExamTip': 'Take your quiz to see what you have aquired in this course!',
  'course.nonCertification': 'Non-Certification',
  'course.certification': 'Certification'
}

// 非认证课程
const videoModule = {
  'educationalVideo.filter': 'Educational Video Filters',
  'educationalVideo.filter.productLine': 'Product Line',
  'educationalVideo.filter.videoType': 'Video Type'
}

// 面授课程
const classroomModule = {
  'classroom.searchPlaceholder': 'Type key words here…',
  'classroom.capacity': 'Capacity',
  'classroom.remaining': 'Remaining',
  'classroom.credits': 'Credits',
  'classroom.maxCapacity': 'Maximum Capacity',
  // 'classroom.enrollTimeLimit': 'Enroll at least 24 hours before training',
  'classroom.enrollTimeLimit.enroll': 'enroll at least',
  'classroom.enrollTimeLimit.before': 'hours before training',
  'classroom.enrollTimeLimit.after': 'hours after training',
  'classroom.from': 'From',
  'classroom.on': 'on',
  'classroom.to': 'to',
  'classroom.enroll': 'Enroll',
  'classroom.cancel': 'Cancel',
  'classroom.pending': 'Pending',
  'classroom.unenrolled': 'Unenrolled',
  'classroom.viewEnrollment': 'View enrollment',
  'classroom.unenroll': 'Unenroll',
  'classroom.finished': 'Finished',
  'classroom.checkedIn': 'Checked in',
  'classroom.feedback': 'Feedback',
  'classroom.absent': 'Absent',
  'classroom.expireTip': 'Enrollment has expired.',
  'classroom.trainingInivtation': 'Classroom Training Invitation',
  'classroom.trainingWelcome': 'Welcome to this training',
  'classroom.practicalExamInivtation': 'Practical Exam Invitation',
  'classroom.practicalExamWelcome': 'Welcome to this exam',
  'classroom.onlineTraining': 'Online Training',
  'classroom.onsiteTraining': 'Onsite Training',
  'classroom.certification': 'Certification',
  'classroom.sessions': 'Session',
  'classroom.time': 'Time',
  'classroom.location': 'Location',
  'classroom.trainer': 'Trainer',
  'classroom.operation': 'Operation',
  'classroom.availableSeats': 'Available Seats',
  'classroom.enrollTipOnBindsPractical': 'Please note that there is a practical exam after this training.',
  'classroom.confirmToEnroll': 'confirm to enroll',
  'classroom.noCalendarData': 'No instructor-led training this day',
  'classroom.lengendEnroll': 'Enrolled',
  'classroom.lengendNotEnroll': 'Not enrolled',
  'classroom.online': 'Online',
  'classroom.onsite': 'Onsite',
  'classroom.noListData': 'There is no onsite training released.',
  'classroom.enrollSuccess': 'Enrollment submitted successfully',
  'classroom.enrollAndMailSubscription': 'Enrollment submitted successfully. And mail subscibed successfully',
  'classroom.cancelSuccess': 'Canceled successfully',
  'classroom.unenrollSuccess': 'Unenrolled in successfully',
  'classroom.orderDescription': 'Please note that there will be a theory exam in this training. If you have any special dietary requirements/allergies, please complete below.',
  'classroom.dietaryRequirements': 'Special dietary requirements',
  'classroom.allergies': 'Allergies',
  'classroom.mailSubscriptionPrefix': 'Mail subsciption:',
  'classroom.mailSubscription': ' I would like to subscribe to newsletters and reminder of learning progress (except regular notification mails)',
  'classroom.personalMailSubscription': 'Settings of mail subsciption can be modified here',
  'classroom.selectEnrollMethod': 'Please select an enrollment method first',
  'classroom.enrollByInvitaionCode': 'Enroll by invitation code',
  'classroom.inputInvitatioinCode': 'Please input your invitation code',
  'classroom.enrollTips': 'In the regular "Enroll" mode, it will take about 1-3 working days to review the enrollment. If you have an invitation code, you can select to enroll by invitation code and get approved automatically.',
  'classroom.sureToEnroll': 'Are you sure you would like to enroll in this certification?',
  'classroom.calendar.monday': 'Mon',
  'classroom.calendar.tuesday': 'Tue',
  'classroom.calendar.wednesday': 'Wed',
  'classroom.calendar.thursday': 'Thu',
  'classroom.calendar.friday': 'Fri',
  'classroom.calendar.saturday': 'Sat',
  'classroom.calendar.sunday': 'Sun',
  'classroom.calendar.mobile.monday': 'M',
  'classroom.calendar.mobile.tuesday': 'T',
  'classroom.calendar.mobile.wednesday': 'W',
  'classroom.calendar.mobile.thursday': 'T',
  'classroom.calendar.mobile.friday': 'F',
  'classroom.calendar.mobile.saturday': 'S',
  'classroom.calendar.mobile.sunday': 'S',
  'classroom.unenrollTip': 'Are you sure you want to unenroll from this training? Your reserved seat will be released for registration by other trainees.',
  'classroom.cancelTip': 'Are you sure you want to cancel this training reservation?',
  'classroom.calendar.Jan': 'January',
  'classroom.calendar.Feb': 'February',
  'classroom.calendar.Mar': 'March',
  'classroom.calendar.Apr': 'April',
  'classroom.calendar.May': 'May',
  'classroom.calendar.June': 'June',
  'classroom.calendar.July': 'July',
  'classroom.calendar.Aug': 'August',
  'classroom.calendar.Sep': 'September',
  'classroom.calendar.Oct': 'October',
  'classroom.calendar.Nov': 'November',
  'classroom.calendar.Dec': 'December',
  'classroom.detail.header': 'Instructor-led Training',
  'classroom.detail.description': 'Training Introduction',
  'classroom.detail.viewCertification': 'View Certification',
  'classroom.localTime': 'Local Time',
  'classroom.training': 'Training',
  'classroom.filter.trainingMethod': 'Training method',
  'classroom.filter.country': 'Country',
  'classroom.filter.language': 'Language'
}

// 认证相关
const certificateModule = {
  'certificate.enroll': 'Enroll',
  'certificate.enrollIn': 'Enroll in',
  'certificate.enroll.course': 'self-paced training',
  'certificate.enroll.classroom': 'instructor-led training',
  'certificate.enroll.pendingTip': 'Approval in progress, please wait',
  'certificate.stepEnroll': 'Enroll',
  'certificate.setpLearn': 'Learn',
  'certificate.stepExam': 'Take exams',
  'certificate.apply': 'Apply for certification',
  'certificate.onlineVideoCourse': 'Self-paced Training',
  'certificate.onlineClassroomTrain': 'Instructor-led Online Training ',
  'certificate.onsiteClassroomTrain': 'Instructor-led Onsite Training ',
  'certificate.enrollTip': 'Are you sure you would like to enroll in this certification?',
  'certificate.startExam': 'Start exam',
  'certificate.theoryExamExpireIn': 'The exam will expire in',
  'certificate.applyDialog.apply': 'Apply for certification',
  'certificate.applyDialog.tip': 'Please double check that you have filled in the information correctly. The certificate will exactly reflect your submission on this page as you entered it.',
  'certificate.onlineClassroom': 'Online Classroom',
  'certificate.onsiteClassroom': 'Onsite Classroom',
  'certificate.learningRules': 'Learning Rules',
  'certificate.overviewTip_1': 'Complete the learning task and gain',
  'certificate.overviewTip_2': 'credits to take the exam. You can apply for the certificate after passing the exam.',
  'certificate.viewCertificate': 'View certificate',
  'certificate.registerFailedTip': 'Registration failed',
  'certificate.registerApprovedTip': 'Registration approval',
  'certificate.examTip': 'The examination is divided into theoretical examination and practical examination. Some course only have theoretical examination, If you pass the examination, you can apply for certification.',
  'certificate.readyToApplyTip': 'You have passed the exam. Go and apply for certification.',
  'certificate.appliedTip': "Application request submitted. You'll be notified of the result within three business days.",
  'certificate.appliedSuccessTip': 'Congratulations! Your certificate application succeeded. Please go to My Learning to check your certificate.',
  'certificate.ruleA': 'a.',
  'certificate.ruleADetail': 'You can learn in one of the following ways.',
  'certificate.ruleB': 'b.',
  'certificate.ruleBDetail': 'For self-paced training, you need to complete all compulsory courses and some elective courses to gain enough credits (9 credits for Hikvision Security Certification; 12 credits for General Security Certification) before taking the exam.',
  'certificate.ruleC': 'c.',
  'certificate.ruleCDetail': 'For instructor-led training, you need to complete the online or onsite training delivered by Hikvision certified trainers before taking the exam.',
  'certificate.ruleD': 'd.',
  'certificate.ruleDDetail': 'A theory exam is necessary for all certification programs while a practical exam is required by some certification programs.',
  'certificate.theoryExam.GscRuleA': 'a. Both theory and practical exams for GSC certification have a total score of 100 points. And trainees must score at least 80 points to pass.',
  'certificate.theoryExam.GscRuleB': 'b. Trainees can take the GSC certification exams any time after accumulating 12 credits or completing the online or onsite training courses.',
  'certificate.theoryExam.GscRuleC': 'c. A theory exam lasts for one hour, while the duration of practical exams is determined by the examiner.',
  'certificate.theoryExam.HscRuleA': 'a. Both theory and practical exams for HSC certification have a total score of 100 points. And trainees must score at least 80 points to pass.',
  'certificate.theoryExam.HscRuleB': 'b. Trainees need to take the HSC certification exams within 30 days after accumulating 9 credits or completing the online or onsite training courses.',
  'certificate.theoryExam.HscRuleC': 'c. A theory exam lasts for one hour, while the duration of practical exams is determined by the examiner.',
  'certificate.apply.congratulations': 'Congratulations! Your certificate application succeeded. Please go to My Learning to check your certificate.',
  'certificate.apply.viewCertificate': 'View certificate',
  'certificate.apply.applicationTip': 'After completing the course registration and learning, you can obtain the certificate after taking the theoretical examination and practical examination',
  'certificate.apply.application': 'Apply for certification',
  'certificate.apply.type': 'Type',
  'certificate.apply.name': 'Name',
  'certificate.apply.countryRegion': 'Country/Region Of Residence',
  'certificate.apply.countryRegionTip': 'Please note that the country/region of residence collected here will be shown in your certificate number in the form of region code.',
  'certificate.apply.submitTip': 'By submitting a certification request you agree to our ',
  'certificate.apply.privacyPolicy': 'Privacy Policy',
  'certificate.apply.submit': 'Submit',
  'certificate.empty.onlyClassroom': 'Only instructor-led training provided',
  'certificate.empty.onlyClassroomDesc': 'Self-paced training by video courses is not provided for this certification. Please click "Enter to Enroll" to enroll a classroom to take the instructor-led training onsite or online.',
  'certificate.empty.enterToEnroll': 'Enter to enroll',
  'certificate.enroll.ndTrainerTip': `We would like to inform you that as part of your training, we will need to transfer some of your personal information to a third-party trainer. The transfer of your data will be done in accordance with the General Data Protection Regulation (GDPR), and we will ensure that your personal information is protected to the same standards as it is with us.

    The transfer of your data is solely for the purpose of facilitating your training, and the third-party trainer will be bound by the same obligations of confidentiality and data protection as we are. They will only use your personal information for the purpose of delivering the training and will not share it with any other third party.
    
    If you have any concerns or questions about the transfer of your personal information, please do not hesitate to contact us.
    
    Best regards,
    Hikvision UK`
}

// 认证首页-由于区分gsc / hsc
const certificateListModule = {
  'hscCertificate.publicTip': "Hikvision's certificate training can:",
  'gscCertificate.publicTip': "Hikvision's certificate training can:",
  'hscCertificate.waysToLearn': 'Ways to learn',
  'gscCertificate.waysToLearn': 'Ways to learn',
  'hscCertificate.onlineVideoCourse': 'Self-paced Training',
  'gscCertificate.onlineVideoCourse': 'Self-paced Training',
  'hscCertificate.learnByOnline': 'Get enrolled and learn through online videos, and then take quizzes to get credits. When you gain the needed credits, you may go ahead with the exam and apply for the certificate if you pass.',
  'gscCertificate.learnByOnline': 'Get enrolled and learn through online videos, and then take quizzes to get credits. When you gain the needed credits, you may go ahead with the exam and apply for the certificate if you pass.',
  'hscCertificate.learnByLive': 'Get enrolled and learn through live webinars led by trainers. When you complete the course, you may go ahead with the exam and apply for the certificate if you pass.',
  'gscCertificate.learnByLive': 'Get enrolled and learn through live webinars led by trainers. When you complete the course, you may go ahead with the exam and apply for the certificate if you pass.',
  'hscCertificate.learnByOnsite': 'Get enrolled and learn through onsite training given by trainers. When you complete the course, you may go ahead with the exam and apply for the certificate if you pass.',
  'gscCertificate.learnByOnsite': 'Get enrolled and learn through onsite training given by trainers. When you complete the course, you may go ahead with the exam and apply for the certificate if you pass.',
  'hscCertificate.onlineClassroomTrain': 'Instructor-led Online Training',
  'gscCertificate.onlineClassroomTrain': 'Instructor-led Online Training',
  'hscCertificate.onsiteClassroomTrain': 'Instructor-led Onsite Training',
  'gscCertificate.onsiteClassroomTrain': 'Instructor-led Onsite Training',
  'gscCertificate.title': 'General Security Certification',
  'hscCertificate.title': 'Hikvision Security Certification',
  'gscCertificate.desc': 'This program is open to anyone who would like to start a career in the security industry. Our training courses are designed to help industry practitioners from different backgrounds quickly grow and achieve goals.\n\nYou will be qualified as a Certified General Security Associate or Certified General Security Professional once you finish the relevant courses and exams. Please note that you have to start the certification from the primary level. You have to get a CGSA certificate before you can apply for a CGSP certificate.',
  'hscCertificate.desc': 'This program is open to security professionals who need to deploy Hikvision systems and look for ways to prove their skill and expertise in the security industry.\n\nYou will be qualified as a Hikvision Certified Security Associate, Hikvision Certified Security Professional or Hikvision Certified Security Expert once you finish the relevant courses and exams. Please note that you have to start the certification from the primary level. You have to get an HCSA certificate before you can apply for an HCSP certificate.',
  'hscCertificate.traningOne': "Provide knowledge about Hikvision's variety of product offerings, packages, and solutions, and ways to select products and deploy systems.",
  'hscCertificate.traningTwo': 'Enhance the technical know-how of security professionals to better serve their customers.',
  'hscCertificate.traningThree': 'Give insights and deepen the overall understanding of the security business.',
  'gscCertificate.traningOne': 'Provide general knowledge and skills starting from the entry level.',
  'gscCertificate.traningTwo': 'Introduce core technologies and latest trends of the security industry.',
  'gscCertificate.traningThree': 'Help more novices get started quickly on their career path.',
  'hscCertificate.curriculum': 'Curriculum',
  'gscCertificate.curriculum': 'Curriculum',
  'hscCertificate.viewAllCourses': 'View all courses',
  'gscCertificate.viewAllCourses': 'View all courses',
  'gscCertificate.compulsory': 'Compulsory',
  'hscCertificate.compulsory': 'Compulsory',
  'gscCertificate.elective': 'Elective',
  'hscCertificate.elective': 'Elective',
  'gscCertificate.applyCertificateRule': "a. Now you are a Certified CGSx Engineer! Congratulations and thanks for your efforts!\nb. Don't forget to renew your certificate in two years.",
  'hscCertificate.applyCertificateRule': "a. Now you are a Certified HCSx Engineer! Congratulations and thanks for your efforts!\nb. Don't forget to renew your certificate in two years.",
  'hscCertificate.howToGetACertificate': 'How to get a certificate',
  'gscCertificate.howToGetACertificate': 'How to get a certificate',
  'hscCertificate.startCertificationCourse': 'Start a Certification Course',
  'gscCertificate.startCertificationCourse': 'Start a Certification Course',
  'hscCertificate.startCertificationCourseRule': 'a. You can choose to start a course either online or onsite.\nb. Attend the compulsory & elective courses to learn and get credits for the coming exam.',
  'gscCertificate.startCertificationCourseRule': 'a. You can choose to start a course either online or onsite.\nb. Attend the compulsory & elective courses to learn and get credits for the coming exam.',
  'gscCertificate.takeExams': 'Take Exams',
  'hscCertificate.takeExams': 'Take Exams',
  'gscCertificate.takeExamsRule': 'a. After collecting more than 12 credits through the course learning, you can proceed to take the online theory exam.\nb. Each theory exam allows for two attempts. If you failed both, you have to relearn your certification course.\nc. Some certification programs may require both theory and practical exams.',
  'hscCertificate.takeExamsRule': 'a. After collecting more than 9 credits through the course learning, you can proceed to take the online theory exam.\nb. Each theory exam allows for two attempts. If you failed both, you have to relearn your certification course.\nc. Some certification programs may require both theory and practical exams.',
  'hscCertificate.applyForCertificate': 'Apply for Certification',
  'gscCertificate.applyForCertificate': 'Apply for Certification',
  'gscCertificate.enterToLearn': 'Enter to learn',
  'hscCertificate.enterToLearn': 'Enter to learn',
  'gscCertificate.comingSoon': 'Coming soon',
  'hscCertificate.comingSoon': 'Coming soon'
}

// 考试相关
const examModule = {
  'exam.submitTipOnUnanswered': 'Your exam still has unanswered questions. You cannot change your answers after submitting.',
  'exam.submitTip': 'Are you sure to submit?',
  'exam.timeoutTip': 'Sorry, the exam has timed out.',
  // 考试时登出，阻止用户logout
  'exam.logoutOnExam': "You haven't submitted your answers. Make sure you click the Submit button before logging out.",
  'exam.back': 'Back',
  'exam.goBack': 'Go back',
  'exam.confirmSubmit': 'Confirm submission',
  'exam.submit': 'Submit',
  'exam.nextPage': 'Next page',
  'exam.previousPage': 'Previous page',
  'exam.startExam': 'Start exam',
  'exam.startExamAgain': 'Take the exam again',
  'exam.result.pass': 'Passed',
  'exam.result.fail': 'Fail',
  'exam.result.failTip': 'Sorry, you failed',
  'exam.result.failOnce': 'You did not pass the exam this time. You may retake the exam when you are ready to earn a higher score.',
  'exam.result.failTwice': 'You failed the exam twice. You have to relearn the relevant courses before you can retake the exam.',
  'exam.result.examChance': 'Examination opportunities',
  'exam.result.attetion': 'Attetion',
  'exam.result.failTip1': 'If you want to take the test again,you need to register for study this certification course again,and your study progress will became 0',
  'exam.result.failTip2': '(However,the study times will be recourded in the study history and will appear in the user center)',
  'exam.result.back': 'Back',
  'exam.result.goPracticalTip': 'You can go to practical exam now.',
  'exam.result.goApplyTip': 'You can apply for certificate now.',
  'exam.result.goPractical': 'Go to practical exam',
  'exam.result.goApply': 'Apply for certificate',
  'exam.result.testAgain': 'Take the test again',
  'exam.result.relearning': 'Relearning',
  'exam.result.viewAnalysis': 'Incorrect answers analysis',
  'exam.countdown': 'Time left',
  'exam.examCongratulation': 'Congratulation you have passed the exam',
  'exam.congratulation': 'Congratulations',
  'exam.applyForCertification': 'Apply for certification',
  'exam.quizRule': 'Quizzes for GSC and HSC certifications have a total score of 100 points, with 20 points per question. Trainees must score at least 60 points to pass and earn the credits.',
  'exam.takeTheQuizAgain': 'Take the quiz again',
  'exam.takeTheExamAgain': 'Take the exam again',
  'exam.earnCredits': 'Credits earned: ',
  'exam.totalCredits': 'Your total credits: ',
  'exam.quizFailDescribe': 'You may retake the quiz when you are ready to earn a higher score.',
  'exam.quizFailTitle': 'You did not pass the quiz this time.',
  'exam.testFailed': 'Sorry, you failed this test.',
  'exam.yourScore': 'Your score',
  'exam.quizSuccessDesc': 'Congratulations on passing this quiz.',
  'exam.get': 'You get',
  'exam.quizCreditsDesc': 'credits in this exam, and accumulated credits increases to',
  'exam.credits': 'credits.',
  'exam.theoryExamPass': 'Passed the theory Exam',
  'exam.theoryExamDesc': 'You have passed the theory exam.',
  'exam.theoryExamFail': 'Theory exam failure',
  'exam.theoryExamFailDesc': 'You failed your first theory test. You still have another chance.',
  'exam.examSuccessDescBeforePracticalExam': 'Congratulations! You may proceed to the practical exam now.',
  'exam.examSuccessDescBeforeApply': 'Congratulations! You may now apply for the certificate.',
  'exam.examinationOpportunities': 'Remaining opportunities:',
  'exam.userUnqualify': 'Sorry, you are not qualified for the exam.',
  'exam.question.pickOne': 'Pick One',
  'exam.question.multiple': 'Multiple Correct',
  'exam.question.trueOrFalse': 'True or False',
  'exam.answerSheet': 'Answer sheet',
  'exam.analysis.yourAnswer': 'Your answer:',
  'exam.analysis.correctAnswer': 'Correct answer:',
  'exam.analysis.answerAnalysis': 'Answer Analysis:',
  'exam.myExam': 'My Exam',
  'exam.quizRules': 'Quiz rule',
  "exam.topicRule": 'The exam comprises with multiple-choice questions and true/false questions. To successfully pass the exam, you are requried achieve a score of 80 points or above out of the total 100 points.'
}

// 错误和异常
const exceptionModule = {
  'error.sorry': 'Sorry, there was an error on the page.',
  'error.notFound': "404, the page doesn't exist.",
  'error.400': 'Data Anomaly',
  'error.403': 'Request Method Anomaly',
  'error.500': 'Some problem occurs, please send an email to eLearninglobal@hikvision.com with the screenshot and the occurrence time.',
  'error.200001  ': 'Third-Party Service Anomaly',
  'error.30000': 'Failed to get the exam paper, please send an email to eLearninglobal@hikvision.com with the screenshot and the occurrence time.',
  'error.30001': 'Failed to submit the answer, please send an email to eLearninglobal@hikvision.com with the screenshot and the occurrence time.',
  'error.30002': 'Failed to start the exam, please send an email to eLearninglobal@hikvision.com with the screenshot and the occurrence time.',
  'error.30003': 'Failed to renew the exam, please send an email to eLearninglobal@hikvision.com with the screenshot and the occurrence time.',
  'error.10000': 'Incorrect invitation letter.',
  'error.10001': 'Your invitation letter has expired. Please get a new letter from sales.',
  'error.10002': 'apply processing not allow repeat submit',
  'error.10003': 'You already obtained a certificate of this certification.',
  'error.10004': 'apply name can not be null',
  'error.10005': 'Your invitation letter is invalid. Please get a new letter to enroll.',
  'error.10006': 'Your invitation letter is used. Please get a new letter to enroll.',
  'error.10007': 'Failed to enroll. Please use the same email you used to receive invitation letter to register or login.',
  'error.10008': 'This practical exam is fully enrolled, please choose another one.',
  'error.10009': 'Please complete the current practical exam before enrolling a new one, you can enroll a new one if not pass the current one',
  'error.10010': "You don't need to enroll the practical exam of this certification again until your obtained certificate gets expired",
  'error.10011': "It's not allowed to cancel the enrollment within 24 hours before the training starts.",
  'error.10012': 'For approved/rejected trainees, you only can invite them to take practical exam. Please select the trainees, and click ‘Invite’ to send them invitation email of practical exam.',
  'error.10013': 'Enrollment has expired',
  'error.10014': 'This instructor-led training is fully enrolled, please choose another one.',
  'error.10015': 'Please complete the current instructor-led training before enrolling a new one, you can enroll a new one after finishing the current one without getting certificate',
  'error.10016': "You don't need to enroll the training of this certification again until your obtained certificate gets expired, while you can watch video courses online any time",
  'error.10017': 'You have already enrolled without invitation letter.',
  'error.10018': 'The invitation letter is only valid in {site} site.',
  'error.10019': 'The invitation letter is only valid for the classroom in {country}.',
  'error.10022': 'Too frequent query is not allowed. Please try later.',
  'error.20036': 'Submitting failed. Your last application is still under pending.'
}

// gdpr
const GDPRModule = {
  // 'gdpr.popupTip': 'This website uses cookies to store info on your device. Cookies help our website work normally and show us how we can improve your user experience. By continuing to browse the site you are agreeing to our cookie policy and privacy policy.',
  'gdpr.accept': 'Accept all',
  'gdpr.reject': 'Reject all',
  'gdpr.manage': 'Manage cookie',
  'gdpr.on': 'On',
  'gdpr.off': 'Off',
  'gdpr.provider': 'Provider',
  'gdpr.cookie': 'Cookie',
  'gdpr.cookieType': 'Cookie-Type',
  'gdpr.purpose': 'Purpose',
  'gdpr.lifespan': 'Lifespan',
  'gdpr.strictCookieTitle': 'Strictly Necessary Cookies',
  'gdpr.strictCookieDesc': 'These cookies are essential in order to enable you to move around the site and use features of the site securely. Without these cookies, you may not be able to take full advantage of the features and functions of the website. ',
  'gdpr.functionCookieTitle': 'Functionality Cookies',
  'gdpr.functionCookieDesc': 'These cookies are used to recognize you and remember your preferences or settings when you return to the site.',
  'gdpr.analyticsCookieTitle': 'Analytics Cookies',
  'gdpr.analyticsCookieDesc': 'We use different types of analytical cookies that allow us to provide you with more efficient and contextual support and that also provide us with data around your usage of the site that we may use to improve the site but also to benefit our business and the businesses of our affiliates, including with respect to business purposes unrelated to the site. For example, we use Google Analytics to monitor traffic levels, search queries and visits to our website.',
  'gdpr.provider.companyName': 'Hikvision',
  'gdpr.provider.atidvisitor': 'AT Internet',
  'gdpr.provider.AtInternet': 'AT Internet',
  'gdpr.provider.ga': 'Google Analytics',
  'gdpr.cookieType.persistent': 'Persistent cookie',
  'gdpr.expire.oneYear': '1 year',
  'gdpr.expire.twoYear': '2 years',
  'gdpr.expire.thirtyMins': '30 mins',
  'gdpr.expire.oneDay': '24 hours',
  'gdpr.expire.ninetyDay': '90 days',
  'gdpr.expire.months': 'months',
  'gdpr.cookie.disclaimer': 'cookie-disclaimer',
  'gdpr.cookie.disclaimerDesc': 'It is to record the close actions of the cookir privacy by user',
  'gdpr.cookie.casToken': 'token',
  'gdpr.cookie.casTokenDesc': 'It is used to identify the login status of users and give corresponding permissions.',
  'gdpr.cookie.hikId': 'HIKID',
  'gdpr.cookie.hikIdDesc': 'Used for server code to read the current user ID (Encrypted)',
  'gdpr.cookie.atConfig': 'AT Internet',
  'gdpr.cookie.atConfigDesc': 'AT Internet cookie. Visitor ID for client-side cookie sites.',
  'gdpr.cookie.system': 'SourceSystem',
  'gdpr.cookie.systemDesc': 'Used for redirection to SSO site correctly.',
  'gdpr.cookie.hikUsername': 'HIKUSERNAME',
  'gdpr.cookie.hikUsernameDesc': 'Used for forms automatically filled which can help log-in user finish form easily and is encrypted.',
  'gdpr.cookie.atidvisitor': 'atidvisitor',
  'gdpr.cookie.atidvisitorDesc': 'AT Internet cookie. List of numsites encountered by the visitor and storage of identified visitor information.',
  'gdpr.cookie.atuserid': 'atuserid',
  'gdpr.cookie.atuseridDesc': 'AT Internet cookie. Visitor ID for client-side cookie sites.',
  'gdpr.cookie._ga': '_ga',
  'gdpr.cookie._gaDesc': 'Google Analytics cookie. Used to distinguish users.',
  'gdpr.cookie._gaCode': '_ga_DTRH106XZH',
  'gdpr.cookie._gaCodeDesc': 'Google Analytics cookie. Used to persist session state.',
  'gdpr.cookie._gid': '_gid',
  'gdpr.cookie._gidDesc': 'Google Analytics cookie. Used to distinguish users.',
  'gdpr.cookie._gcl_au': '_gcl_au',
  'gdpr.cookie._gcl_auDesc': 'Used to help advertisers determine how many times users who click on their ads end up taking an action on their site.',
  'gdpr.popup.gdprTextOne': 'uses strictly necessary cookies and related technologies to enable the website to function, namely to authenticate you, secure our service, save certain preferences, record your cookie preferences, observe and analyse traffic levels and other metrics.',
  'gdpr.popup.gdprTextTwo': 'With your consent, we would also like to use cookies to observe and analyse traffic levels and other metrics, show you targeted advertising, show you advertising on the basis of your location. You can always object to and change the use of these cookies by using the',
  'gdpr.popup.gdprTextThree': 'button on the website',
  'gdpr.popup.gdprTextFour': 'For more information including third parties who use cookies on our website on cookie practices please refer to our',
  'gdpr.popup.cookiePolicy': 'cookie policy',
  'gdpr.popup.manageCookie': 'Manage Cookies'
}

const myLearningModule = {
  'myLearning.noVideoCourses': 'You have not completed any video courses yet.',
  'myLearning.noVideoCoursesOnFilter': 'No such courses were filtered out.',
  'myLearning.myCredit': 'My Credit',
  'myLearning.currentCredits': 'Current credits',
  'myLearning.requiredCredits': 'Required credits',
  'myLearning.personalInformation': 'Personal Information',
  'myLearning.Preferences': 'Preferences',
  'myLearning.myCertificates': 'My Certificates',
  'myLearning.inProgress': 'In progress',
  'myLearning.continue': 'Continue',
  'myLearning.examList': 'My Exams & Quizzes',
  'myLearning.selfpacedTraining': 'Self-paced Training',
  'myLearning.instructorledTraining': 'Instructor-led Training',
  'myLearning.noTest': 'No test',
  'myLearning.noTestDesc': "Sorry. You don't have a test yet.",
  'myLearning.goCertification': 'Go to the certification',
  'myLearning.selfPaced': 'Self-paced',
  'myLearning.credit': 'Credit',
  'myLearning.quiz': 'Quiz',
  'myLearning.pass': 'Pass',
  'myLearning.finished': 'Finished',
  'myLearning.fail': 'Fail',
  'myLearning.status': 'Status',
  'myLearning.score': 'Score',
  'myLearning.theoryExam': 'Theory exam',
  'myLearning.startTheoryExam': 'Start Theory exam',
  'myLearning.practicalExam': 'Practical exam',
  'myLearning.startPracticalExam': 'Start Practical exam',
  'myLearning.instructorLed': 'Instructor-led',
  'myLearning.aaiTip': 'HCSA-AAI is divided into HCSA-Access Control, HCSA-Video Intercom and HCSA-Alarm. HCSA-AAI certificate equals to certificates of these 3 certifications.',
  'myLearning.edit.upload': 'Upload',
  'myLearning.edit.email': 'Email',
  'myLearning.edit.firstName': 'First Name',
  'myLearning.edit.lastName': 'Last Name',
  'myLearning.edit.code': 'Code',
  'myLearning.edit.phoneNumber': 'Phone Number',
  'myLearning.edit.jobTitle': 'Job title',
  'myLearning.edit.type': 'Type',
  'myLearning.edit.companyName': 'Company Name',
  'myLearning.edit.city': 'City',
  'myLearning.edit.postcode': 'Postcode',
  'myLearning.edit.address': 'Address',
  'myLearning.edit.country': 'Country/Region',
  'myLearning.edit.language': 'Country/Language',
  'myLearning.edit.province': 'Province/State',
  'myLearning.edit.submit': 'Submit',
  'myLearning.edit.deleteTip': 'If you no longer use this account and want to delete it.',
  'myLearning.edit.languageTip': 'Please select country/region of residence here. The available training sessions may differ based on your country.',
  'myLearning.edit.clickToContinue': 'Click to continue',
  'myLearning.edit.pleaseInputFirstName': 'Please input firstName',
  'myLearning.edit.pleaseInputLastName': 'Please input lastName',
  'myLearning.edit.pleaseInputPhone': 'Please input phone number',
  'myLearning.edit.pleaseInputCountry': 'Please select country',
  'myLearning.edit.pleaseInputProvince': 'Please select province',
  'myLearning.edit.pleaseInputCity': 'Please select city',
  'myLearning.edit.pleaseInputPostcode': 'Please input postcode',
  'myLearning.edit.pleaseInputAddress': 'Please input address',
  'myLearning.edit.pleaseInputCompany': 'Please input company',
  'myLearning.edit.pleaseInputType': 'Please select type',
  'myLearning.edit.vatLengthError': 'Please enter numbers with at least 2 digits.',
  'myLearing.needPaperCertificate': 'Need paper certificate',
  'myLearing.certificateDialogFrom': 'Please get your certificate from',
  'myLearing.certificateDialogInfo': 'Contact  Person: Eben.Venter \nTel: +86 15672849382',
  'myLearing.certificateDialogInfoAddress': 'Address: Unit 13 Cordwallis Park, Clivemont Road, Maidenhead, United Kingdom, SL6 7BU',
  'myLearning.viewMore': 'View more',
  'myLearning.startExam': 'Start exam',
  'myLearning.applyCertificate': 'Apply for certificate',
  'myLearning.reEnroll': 'Re-enroll',
  'myLearning.passed': 'Passed',
  'myLearning.noCourseDesc': 'Welcome to an excellent online learning experience!',
  'myLearning.noCertificate': 'No certificate found',
  'myLearning.noCertificateDesc': 'Complete your learning journey and gain your certificate!',
  'myLearning.noFound': 'No record found',
  'myLearning.noClassroomDesc': 'Join us for an greate instructor-led training experience. We\'re excited to learn and grow with you!',
  'myLearning.certificateName': 'NAME',
  'myLearning.certificateNumber': 'CERTIFICATION NUMBER',
  'myLearning.certificateValid': 'VALID UNTIL',
  'myLearning.aboutToExpired': 'About to expired',
  'myLearning.expired': 'Expired',
  'myLearning.renew': 'Renew',
  'myLearning.pleaseRenew': 'The certificate is about to expire, please renew it in time',
  'myLearning.nonCertificationNoDataDesc': 'No record found Join us today to explore our abundant educational videos and enrich your knowledge!',
  'myLearning.search': 'Search',
  'myLearning.myEducationalVideo': 'My Educational Video',
  'myLearning.successModify': 'Modified successfully',
  'myLearning.download': 'Download',
  'myLearning.tips.name': 'Trainers may reach out to you promptly in case of any modifications to the instructor-led training sessions and easy to generate a valid certificate.',
  'myLearning.tips.phone': 'Trainers may reach out to you promptly in case of any modifications to the instructor-led training sessions.',
  'myLearning.tips.provinceState': 'Trainers may tailor their training session recommendations to you based on your specific location.',
  'myLearning.tips.city': 'Trainers may tailor their training session recommendations to you based on your specific location.',
  'myLearning.tips.postcode': 'Trainers may tailor their training session recommendations to you based on your specific location.',
  'myLearning.tips.address': 'Trainers may recommend you of the training session based on your location.',
  'myLearning.edit.vat': 'VAT',
  'myLearning.tips.vat': 'The provision of a VAT number is necessary in order to get benefits after certification.',
  'myLearning.edit.pleaseInputVat': 'Please input vat'
}

const searchModule = {
  'search.searchInputPlaceholder': 'Please input keywords for searching'
}

const topicModule = {
  'topic.examRequired': 'Exam required',
  'topic.videos': 'Videos',
  'topic.topic': 'Topic'
}

const trainerTeamModule = {
  'trainerTeam.meetTrainers': 'Meet our trainers',
  'trainerTeam.overview': "The Hikvision eLearning trainers' team features the most experienced security experts from Hikvision and partner organizations worldwide. These trainers come from professional fields including product design, AI algorithm research, pre-sales, delivery, after-sales, customer training, and more. \nThey are well-equipped to provide authoritative courses about cutting-edge products and solutions and to prepare you for the security industry today and tomorrow.",
  'trainerTeam.joinTeam': 'Join our trainer team',
  'trainerTeam.takeChance': 'Take the chance to inspire and empower',
  'trainerTeam.joinTeamReasonOne': 'Independently or assist the teaching team to carry out security-related course topics and content validation, course material collection and compilation, course update and development, course review and release, etc. according to Hikvision eLearning course development and management rules',
  'trainerTeam.joinTeamReasonTwo': 'Deliver courses online and onsite as authorized by Hikvision eLearning platform, including the organization of classes, exams, certificate issuance, etc.',
  'trainerTeam.joinTeamReasonThree': 'Create and review video courses in accordance with course production and review requirements, and with the authorization of Hikvision eLearning platform',
  'trainerTeam.getReward': "You'll get the following regarding Hikvision eLearning courses",
  'trainerTeam.rewardOne': 'Knowledge and experience in professional course development',
  'trainerTeam.rewardTwo': 'Knowledge and experience in professional speech and lecture delivery',
  'trainerTeam.rewardThree': 'General knowledge of professional security products and solutions',
  'trainerTeam.rewardFour': "Annual incentive and recognition for course development and lecture delivery based on learners' feedback",
  'trainerTeam.starTrainer': 'Star trainers',
  'trainerTeam.localTrainer': 'Local trainers',
  'trainerTeam.dialogTips': 'You acknowledge and agree that the information collected by us above is to be used for convenient contact, qualification review, and screening. We will review your resume and inform you of our decision within 7 business days of submission. Please note that submission of a resume alone is not sufficient to become a trainer. If Hikvision declines your application to become a trainer, all personal data submitted to us through this webpage will be automatically deleted within 3 business days.',
  'trainerTeam.joinUsDesc': 'If you have professional experience in the security industry and are excited about sharing your knowledge, Hikvision eLearning cordially invites you to join our team of course developers and instructors.',
  'trainerTeam.joinUs': 'Join us'
}

// 实操练习
const handsOnModule = {
  'handsOn.handsOnPractice': 'Hands-on Practice',
  'handsOn.start': 'Start the practice',
  'handsOn.startAgain': 'Take the practice again',
  'handsOn.congratulations': 'Congratulations',
  'handsOn.congratulationDesc': 'Congratulations on passing the hands-on practice !',
  'handsOn.ruleOne': 'a.  Please take the hands-on practice before taking the quiz, and you can take the hands-on practice as many times as you want.',
  'handsOn.ruleTwo': 'b.  It is recommended to follow the steps or read the hints when you take the hands-on practice task.',
  'handsOn.mobileUnavailable': "I'm sorry that the hands-on practice is not available on mobile devices temporarily, please log in to the web portal of Hikvision eLearning. Thank you.",
  'handsOn.mobileIframeUnavailable': "I'm sorry that the hands-on practice/ practical exam is not available on mobile devices temporarily, please log in to the web portal of Hikvision eLearning. Thank you."
}

// 实操考试
const practicalExamModule = {
  'practicalExam.practicalExam': 'Practical Exam',
  'practicalExam.skillLearn.practicalExam': 'Practical Exam',
  'practicalExam.startExam': 'Start the exam',
  'practicalExam.successTitle': 'Congratulations',
  'practicalExam.successDesc': 'Congratulations on passing the practical exam! Please apply for the certificate now.',
  'practicalExam.failTitle': 'Sorry',
  'practicalExam.failDesc': 'Please finish the practical exam',
  'practicalExam.continue': 'Continue',
  'practicalExam.courseTip': 'We recommend you to watch the video courses first before taking hands-on practice.',
  'practicalExam.needLoginForExercise': 'You need to log in for hands-on practice.',
  'practicalExam.needLoginforExam': 'You need to log in for practical exam.',
  'practicalExam.skillLearn.ruleA': 'a. Both theory and practical exams have a total score of 100 points, and trainees must score at least 80 points to pass.',
  'practicalExam.skillLearn.ruleB': 'b. Trainees can take the practical exam after accumulating 9 credits.',
  'practicalExam.skillLearn.ruleC': 'c. Both the theory exam and online practical exam last for one hour, while the duration of the onsite practical exam is determined by the examiner.',
  'practicalExam.skillLearn.mobileUnavailableTip': "I'm sorry that the practical exam is not available on mobile devices temporarily, please log in to the web portal of Hikvision eLearning. Thank you.",
  'practicalExam.traditional.practicalExam': 'Practical Exam',
  'practicalExam.traditional.examRules': 'Exam Rules:',
  'practicalExam.traditional.gscRuleA': 'a. Both theory and practical exams for GSC certification have a total score of 100 points. And trainees must score at least 80 points to pass.',
  'practicalExam.traditional.gscRuleB': 'b. Trainees can take the GSC certification exams any time after accumulating 12 credits or completing the online or onsite training courses.',
  'practicalExam.traditional.gscRuleC': 'c. A theory exam lasts for one hour, while the duration of practical exams is determined by the examiner.',
  'practicalExam.traditional.hscRuleA': 'a. Both theory and practical exams for HSC certification have a total score of 100 points. And trainees must score at least 80 points to pass.',
  'practicalExam.traditional.hscRuleB': 'b. Trainees need to take the HSC certification exams within 30 days after accumulating 9 credits or completing the online or onsite training courses.',
  'practicalExam.traditional.hscRuleC': 'c. A theory exam lasts for one hour, while the duration of practical exams is determined by the examiner.',
  'practicalExam.traditional.enroll': 'Enroll',
  'practicalExam.traditional.unenroll': 'Unenroll',
  'practicalExam.traditional.pending': 'Pending',
  'practicalExam.traditional.viewEnrollment': 'View enrollment',
  'practicalExam.traditional.unenrolled': 'Unenrolled',
  'practicalExam.traditional.success': 'Success',
  'practicalExam.traditional.fail': 'Fail',
  'practicalExam.traditional.absent': 'Absent',
  'practicalExam.traditional.sessions': 'Sessions',
  'practicalExam.traditional.time': 'Time',
  'practicalExam.traditional.location': 'Location',
  'practicalExam.traditional.trainer': 'Trainer',
  'practicalExam.traditional.capacity': 'Capacity',
  'practicalExam.traditional.availableSeats': 'Available Seats',
  'practicalExam.traditional.score': 'Score',
  'practicalExam.traditional.operation': 'Operation',
  'practicalExam.traditional.enrollUnavailble': 'Please pass the theory exam first.',
  'practicalExam.traditional.enrollTipContent': 'Are you sure to enroll this practical exam?',
  'practicalExam.cancelTip': 'Are you sure you want to cancel this practical exam reservation?',
  'practicalExam.unenrollTip': 'Are you sure you want to unenroll from this practical exam? Your reserved seat will be released for registration by other trainees.',
  'practicalExam.noAvailableSession': 'No available session',
  'practicalExam.noAvailableSessionDesc': 'Sorry, we will release practical exam soon. Thank you for your patient waiting.'
}

const invitationModule = {
  'invitation.title': 'Hikvision eLearning Training Invitation',
  'invitation.courseIntro': 'Training Introduction',
  'invitation.startEnroll': 'Enroll',
  'invitation.learnMore': 'More Details',
  'invitation.timePrefix': 'Training starts at',
  'invitation.success': 'Enrolled Successfully',
  'invitation.warining': 'You can only enroll once with your invitation letter.',
  'invitation.prompText': 'Are you sure you would like to enroll in this classroom/certification with the invitation letter? Your enrollment will be approved automatically. ',
  'invitation.practicalExamIntro': 'Dear user, you have passed the theoretical exam, and then you can apply for the certificate after passing the practical exam. Please enroll to one practical exam and try to pass it.',
  'invitation.practicalExamTitle': 'Invitation letter for Practical Exam',
  'invitation.practicalExamLinkTitle': 'Certification details: ',
  'invitation.practicalExam': 'Practical Exam',
  'invitation.praticalExamEnrollTip': 'Are you sure you would like to enroll in this practical exam with the invitation letter? Your enrollment will be approved automatically. ',
  'invitation.missingInvitationCode': 'Incorrect invitation letter'
}

// 全局
const globalModule = {
  'footer.quickLinks': 'Quick Links',
  'footer.relatedLinks': 'Related Links',
  'footer.joinTeam': 'Join us as a trainer',
  'footer.strategicPartners': 'Strategic Partners',
  'footer.joinTeamDesc': "When you join our trainers'team, you'll get the chance to earn new opportunities and generous rewards.",
  'footer.contactUs': 'Contact us',
  'footer.pleaseContact': 'If you have any questions, please contact ',
  'footer.contactEmail': 'eLearninglobal@hikvision.com',
  'footer.joinUs': 'Join us',
  'header.certification': 'Certification',
  'header.nonCertification': 'Non-Certification',
  'header.educationalVideo': 'Educational Video',
  'header.logout': 'Log out',
  'header.login': 'Log in',
  'header.signin': 'Sign up',
  'header.countryLanguageTips1': 'Your country/language is defaultly selected as',
  'header.countryLanguageTips2': 'If you need to change it, Please click',
  'header.countryLanguageTips3': 'country/language setting',
  'header.search': 'Search',
  'header.personalInfo': 'Personal Information',
  'header.generalSecurityCertification': 'General Security Certification',
  'header.hikSecurityCertification': 'Hikvision Security Certification',
  'header.resetPassword': 'Reset password',
  'header.onlineVideoCourses': 'Self-paced Training',
  'header.Overview': 'Overview',
  'header.instructor-ledTraining': 'Instructor-led Training',
  'header.myLearning': 'My Learning',
  'global.noMoreData': 'No More Data',
  'global.loading': 'Loading...',
  'global.learningProgress': 'Learning progress',
  'global.startQuiz': 'Start Quiz',
  'global.signIn': 'Sign In',
  'global.needLoginFirst': 'You need to log in first',
  'global.enrollSubmitSuccess': 'Submit successfully, and will auto enroll the certification of this course, registration result will be notified by email!',
  'global.typeKeyword': 'Type key words here',
  'global.search-title': 'Find what you need with Search',
  'global.GSCOveriewDesc': 'The General Security Certification Program focuses on the universal knowledge and skills needed in the security industry, from technical principles to typical solution design.',
  'global.HSCOveriewDesc': 'The Hikvision Security Certification Program revolves around Hikvision products and solutions, covering system configuration, operation, troubleshooting, and more.',
  'global.copyrightInfo': '2022 Hangzhou Hikvision Digital Technology Co., Ltd.All Rights Reserved.',
  'global.session': 'Session',
  'global.time': 'Time',
  'global.liveLink': 'Live Link',
  'global.location': 'Location',
  'global.password': 'Password',
  'global.gotit': 'Got it',
  'global.filter.all': 'All',
  'global.filter.allCountry': 'All country',
  'global.filter.studying': 'Studying',
  'global.filter.waitForQuiz': 'Wait for quiz',
  'global.filter.pass': 'Pass',
  'global.filter.compulsory': 'Compulsory',
  'global.filter.elective': 'Elective',
  'global.filter.submit': 'Submit',
  'global.continue': 'Continue',
  'global.accept': 'Accept',
  'global.reject': 'Reject',
  'global.selectLanguage': 'Select Your Country and Language',
  'global.languageTips': 'Please select country/region of residence here. The available training sessions may differ based on your country.',
  'global.change': 'Change',
  'global.confirm': 'Confirm',
  'global.back': 'Back',
  'global.noData': 'No Data',
  'global.fillPersonalInfo': 'Fill in Personal Information',
  'global.gatheringDetail': 'Hikvision Certification Program is open to security professionals who need to deploy Hikvision systems and look for ways to prove their skill and expertise in the security industry. To enhance our training offerings, we kindly request that you provide us with additional information. The hints for each information item clarifies the specific reasons for its collection. For more details, please refer to',
  'global.privacyPolicy': 'Privacy Policy.',
  'global.ipRemindTip': 'Please note that your current location does not match the training location, which may result in your registration being rejected. Please carefully confirm if you still wish to register for this training.',
  'global.country': 'Country',
  'global.language': 'Language',
  'global.loginTip': 'Please log in or create an eLearning account before proceeding. If you do not have an account, you may also use your Hikvision official website account or your Hik-Partner Pro account to log in. Once logged in, please return to eLearning to enroll in the course.'
}

const newsModule = {
  'news.date': 'Date:',
  'news.topic': 'Topic:',
  'news.searchPlaceHolder': 'Input news title or topic here',
  'news.backToNewsList': 'Back to news list',
  'news.resultsFound': 'results found'
}

const vatModule = {
  'vat.title': 'Certification Query',
  'vat.tips': 'You can search for the Hikvision certification types obtained by a company using its VAT number.',
  'vat.searchInputPlaceholder': 'Please search by VAT number, eg.123456789',
  'vat.expirationDate': 'Expiration Date'
}

Object.assign(message, {
  ...homeModule,
  ...classroomModule,
  ...exceptionModule,
  ...globalModule,
  ...courseModule,
  ...certificateModule,
  ...GDPRModule,
  ...examModule,
  ...myLearningModule,
  ...searchModule,
  ...trainerTeamModule,
  ...certificateListModule,
  ...handsOnModule,
  ...practicalExamModule,
  ...invitationModule,
  ...newsModule,
  ...videoModule,
  ...topicModule,
  ...vatModule
})

export default message
